import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { FixedAssetStatus, Role, Team } from '@/hooks/api/models';

/**
 * 1990. 固定資産状態一覧
 * [GET] /fixed_asset_statuses
 */
const fixedAssetStatuses = (): Promise<FixedAssetStatus[]> => {
  return axios.get(`/api/fixed_asset_statuses`);
};

export const useFixedAssetStatuses = () => {
  return useQuery({
    queryKey: ['fixed_asset_statuses'],
    queryFn: () => fixedAssetStatuses(),
  });
};
